import { ListGroupItem } from "reactstrap";
import { Link } from "react-router-dom";
import { PropsWithChildren } from "react";
import { selectedClasses } from "../list/ClassModifiers";

interface Props {
  isSelected: boolean;
  to?: string;
  onClick?: () => void;
}

export function EntryContent({
  children,
  isSelected,
  to,
  onClick,
}: PropsWithChildren<Props>) {
  return (
    <ListGroupItem
      action
      className={"border-0 rounded-0 " + selectedClasses(isSelected)}
      tag={to ? Link : "button"}
      to={to}
      onClick={onClick}
      style={{ minWidth: 0 }}
    >
      {children}
    </ListGroupItem>
  );
}
